import { create } from 'zustand'

interface UrgencyState {
  /** S 波倒计时进入最后 10 秒：全屏紧迫视觉（vignette + shake） */
  urgent: boolean
  setUrgent(urgent: boolean): void
}

/** S 波临近紧迫态。由 WaveArrivals 每次倒计时刷新时同步，CommandPage 消费。 */
export const useUrgencyStore = create<UrgencyState>((set) => ({
  urgent: false,
  setUrgent: (urgent) =>
    set((s) => (s.urgent === urgent ? s : { urgent })),
}))
